module.exports = __webpack_public_path__ + "media/images/google-logo-752536d8059d2a92ec94472b9b6de366.svg";